export enum ContentType {
  MOVIE = 0,
  SERIES = 1,
  BOOK = 2,
  PODCAST = 3,
  GAME = 4,
  FORMAT = 5,
  STORY = 6,
  IP = 7,
  MICROSERIES=8,
}
export enum EntityType {
  company = 'COMPANY',
  content = 'CONTENT',
  person = 'PERSON',
}
export enum ContentSourceType {
  DELI = 'DELI',
  TMDB = 'TMDB',
  GVD = 'GVD',
  // SELLER_CATALOGUE = 'SELLER CATALOGUE',
  //https://vdovitrina-ai.atlassian.net/wiki/spaces/VSDI/pages/432242763/Quadruple+updation
}
export enum ContentStatus {
  'canceled' = 'Canceled',
  'ended' = 'Ended',
  'in_production' = 'In Production',
  'pilot' = 'Pilot',
  'planned' = 'Planned',
  'post_production' = 'Post Production',
  'released' = 'Released',
  'returning_series' = 'Returning Series',
  'rumored' = 'Rumored',
}

export enum ContentRatings {
  'L' = 'L',
  'TV-Y' = 'TV-Y',
  'None' = 'None',
  '_12' = '12',
  'TV-G' = 'TV-G',
  '_10' = '10',
  '-' = '-',
  'TV-MA' = 'TV-MA',
  'passed' = 'passed',
  '_15' = '15',
  'USA:Approved' = 'USA:Approved',
  'TV-Y7' = 'TV-Y7',
  'Y' = 'Y',
  'Approved' = 'Approved',
  'PG' = 'PG',
  'TV-PG' = 'TV-PG',
  'Not_Rated' = 'Not Rated',
  'R' = 'R',
  'UR' = 'UR',
  '_2009' = '2009',
  'Unrated' = 'Unrated',
  'NRW' = 'NRW',
  'NR' = 'NR',
  'M' = 'M',
  'X' = 'X',
  'TV-14' = 'TV-14',
  ',R' = ',R',
  'G' = 'G',
  'NC-17' = 'NC-17',
  'Exempt' = 'Exempt',
  'MA' = 'MA',
  'PG-13' = 'PG-13',
  'nr' = 'nr',
  'IMDB' = 'IMDB',
  'A' = 'A',
}

export enum VideoSite {
  'YouTube' = 'YouTube',
  'Vimeo' = 'Vimeo',
}
export enum VideoType {
  'Behind the Scenes' = 'Behind the Scenes',
  'Bloopers' = 'Bloopers',
  '4k' = '4k',
  'Teaser' = 'Teaser',
  'Clip' = 'Clip',
  'Opening Credits' = 'Opening Credits',
  'Trailer' = 'Trailer',
  'Featurette' = 'Featurette',
}

export enum MediaType {
  IMAGE = 0,
  VIDEO = 1,
}

export enum PublishStatus {
  'PS_-1' = 'Manually Unpublished',
  'PS_0' = 'Auto Unpublished',
  'PS_1' = 'Auto Published',
  'PS_2' = 'Manually Published',
  'PS_-2' = 'Parked',
}

export enum PublishStatusEnumNumeric {
  'Manually Unpublished' = -1,
  'Auto Unpublished' = 0,
  'Auto Published' = 1,
  'Manually Published' = 2,
  'Parked' = -2,
}
